import { useForm } from "react-hook-form";
import {
  IMyFamilyWizardFormModel,
  myFamilyWizardFormDefaultValues,
  myFamilyWizardFormSchema,
} from "../models/myFamilyWizardFormModel";
import { yupResolver } from "@hookform/resolvers/yup";
import { useEffect } from "react";
import { useFormValidationMessages } from "../../../../../common/infrastructure/hooks/useFormHelper";

export const useMyFamilyWizardForm = (
  currentFamilyData?: IMyFamilyWizardFormModel
) => {
  const form = useForm<IMyFamilyWizardFormModel>({
    defaultValues: myFamilyWizardFormDefaultValues,
    resolver: yupResolver(myFamilyWizardFormSchema),
  });

  useEffect(() => {
    if (currentFamilyData) {
      const firstMember = currentFamilyData.members?.[0];

      form.setValue("id", currentFamilyData.id);
      form.setValue("name", currentFamilyData.name);
      form.setValue(
        "familyHeadId",
        currentFamilyData.familyHeadId ?? firstMember?.id ?? null
      );
    }
  }, [currentFamilyData]);

  useFormValidationMessages<IMyFamilyWizardFormModel>(form);
  return form;
};
